export const filterLabelMappings = {
  referralSource: 'Referral Source',
  status: 'Lead Status',
  waitlist: 'Waitlist Status',
  profileUserType: 'Role',
  spaces: 'Spaces',
  property: 'Property',
  caStatus: 'CA Status',
  company: 'Company',
  broker: 'Brokers',
  listing: 'Spaces',
};
